const MESI = [
  "gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno",
  "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre",
];

function toDate(x) {
  return x instanceof Date ? x : new Date(x);
}

function sameDay(a, b) {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

export function dayLabel(x) {
  const d = toDate(x);
  const now = new Date();
  const yest = new Date();
  yest.setDate(now.getDate() - 1);
  if (sameDay(d, now)) return "Oggi";
  if (sameDay(d, yest)) return "Ieri";
  const y = d.getFullYear() === now.getFullYear() ? "" : ` ${d.getFullYear()}`;
  return `${d.getDate()} ${MESI[d.getMonth()]}${y}`;
}

export function timeLabel(x) {
  const d = toDate(x);
  return d.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });
}

export function relativeSeen(x) {
  if (!x) return "mai";
  const d = toDate(x);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "poco fa";
  if (diff < 3600) return `${Math.floor(diff / 60)} min fa`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} h fa`;
  return `il ${d.getDate()} ${MESI[d.getMonth()]}`;
}

export function dayKey(x) {
  const d = toDate(x);
  return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
}

export function initials(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  return (parts[0][0] + (parts[1]?.[0] || "")).toUpperCase();
}

// deterministic pastel color from a string
export function colorFor(str) {
  let h = 0;
  for (let i = 0; i < (str || "").length; i++) h = (h * 31 + str.charCodeAt(i)) % 360;
  return `hsl(${h} 65% 55%)`;
}

const URL_RE = /(https?:\/\/[^\s]+)/g;

export function linkifyParts(text) {
  const parts = [];
  let last = 0;
  let m;
  URL_RE.lastIndex = 0;
  while ((m = URL_RE.exec(text)) !== null) {
    if (m.index > last) parts.push({ t: "text", v: text.slice(last, m.index) });
    parts.push({ t: "link", v: m[0] });
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push({ t: "text", v: text.slice(last) });
  return parts;
}
